import { apiClient } from '../utils/api-client';
import type {
  PendingTasksPage,
  PendingTasksQuery,
  PendingTasksRefreshResult,
  PendingTasksStatus,
} from '../types/pendingTasks';

class PendingTasksService {
  private baseUrl = '/pending-tasks';

  async getPendingTasks(query: PendingTasksQuery): Promise<PendingTasksPage> {
    const params = new URLSearchParams({
      page: String(query.page),
      per_page: String(query.perPage),
      sort: query.sort,
      direction: query.direction,
    });
    if (query.tier) params.set('tier', query.tier);
    if (query.fundId) params.set('fund_id', query.fundId);
    if (query.companyId) params.set('company_id', query.companyId);
    if (query.category) params.set('category', query.category);
    return apiClient.get<PendingTasksPage>(
      `${this.baseUrl}?${params.toString()}`
    );
  }

  async getStatus(): Promise<PendingTasksStatus> {
    return apiClient.get<PendingTasksStatus>(`${this.baseUrl}/status`);
  }

  async refresh(): Promise<PendingTasksRefreshResult> {
    return apiClient.post<PendingTasksRefreshResult>(`${this.baseUrl}/refresh`);
  }
}

export const pendingTasksService = new PendingTasksService();
